import { FC } from 'react';

import { AdminItem, resolveImageSrc } from '../../../api/client';
import { formatMoney } from '../../../shared/functions/formatter';
import { Button, Dialog, StatusBadge } from '../../../ui';
import { plural } from './types';

type EligibleItemsPreviewProps = {
  open: boolean;
  title: string;
  items: AdminItem[];
  onClose: () => void;
};

/** Every item a category group can draw from, with hidden items named. */
const EligibleItemsPreview: FC<EligibleItemsPreviewProps> = ({ open, title, items, onClose }) => (
  <Dialog
    open={open}
    onOpenChange={(next) => {
      if (!next) onClose();
    }}
    title={title}
    description={plural(items.length, 'eligible item')}
    size="lg"
    className="discountPicker"
    actions={
      <Button variant="secondary" onClick={onClose}>
        Close
      </Button>
    }
  >
    <ul className="discountEligibleList">
      {items.map((item) => (
        <li className="discountEligibleRow" key={item.id}>
          {item.image_url || item.img ? (
            <img className="discountPickerThumb" src={resolveImageSrc(item.image_url || item.img)} alt="" />
          ) : (
            <span className="discountPickerThumb discountGroupThumbEmpty" />
          )}
          <span className="discountEligibleName">{item.title}</span>
          {item.is_hidden && (
            <StatusBadge tone="neutral" dot={false}>
              Hidden
            </StatusBadge>
          )}
          <span className="money">{formatMoney(item.price_cents)}</span>
        </li>
      ))}
    </ul>
  </Dialog>
);

export default EligibleItemsPreview;
